module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "galley-rw"
  }, [_c('section', {
    staticClass: "frontmatter-rw preface-rw auto-rw page-open-left-rw",
    attrs: {
      "epub:type": "frontmatter preface",
      "id": "preface002"
    }
  }, [_c('h1', {
    staticClass: "preface-title"
  }, [_c('a', {
    attrs: {
      "href": "#/toc#toc-preface002"
    }
  })]), _c('div', {
    staticClass: "sidebar"
  }, [_c('div', {
    staticClass: "ext_ch"
  }, [_c('div', {
    staticClass: "decoration-rw10"
  }, [_c('div', {
    staticClass: "media-rw image-rw float-none-rw floatgalley-none-rw align-center-rw width-fixed-rw exclude-print-rw"
  }, [_c('div', {
    staticClass: "pc-rw"
  }, [_c('img', {
    staticClass: "orn1",
    attrs: {
      "alt": "",
      "src": "images/Art_Pviii.jpg"
    }
  })])])])]), _vm._v(" "), _c('p', {
    staticClass: "space-break"
  }, [_vm._v("There was an old woman and she lived in the woods, weile weile waile.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("There was an old woman and she lived in the woods down by the river Saile.")]), _vm._v(" "), _c('p', {
    staticClass: "space-break"
  }, [_vm._v("She had a baby three months old, weile weile waile.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("She had a baby three months old down by the river Saile.")]), _vm._v(" "), _c('p', {
    staticClass: "space-break"
  }, [_vm._v("She had a penknife, long and sharp, weile weile waile.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("She had a penknife long and sharp down by the river Saile.")]), _vm._v(" "), _c('p', {
    staticClass: "space-break"
  }, [_vm._v("She stuck the penknife in the baby’s heart, weile weile waile.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("She stuck the penknife in the baby’s heart down by the river Saile.")]), _vm._v(" "), _c('p', {
    staticClass: "space-break"
  }, [_vm._v("Three hard knocks came knocking on the door, weile weile waile.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("Three hard knocks came knocking on the door down by the river Saile.")]), _vm._v(" "), _c('p', {
    staticClass: "space-break"
  }, [_vm._v("“Are you the woman that killed the child?” weile weile waile.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("“Are you the woman that killed the child down by the river Saile?”")]), _vm._v(" "), _c('p', {
    staticClass: "space-break"
  }, [_vm._v("The rope was pulled and she got hung, weile weile waile.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("The rope was pulled and she got hung down by the river Saile.")]), _vm._v(" "), _c('p', {
    staticClass: "space-break"
  }, [_vm._v("And that was the end of the woman in the woods, weile weile waile.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("And that was the end of the woman in the woods down by the river Saile.")]), _vm._v(" "), _c('p', {
    staticClass: "ca"
  }, [_vm._v("—traditional Irish murder ballad, ca. 1600")])])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-690068b8","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/preface002.vue
// module id = 72
// module chunks = 0